export default __webpack_public_path__ + "static/media/93df2de102eb58e850bac105ee326aa0.png";